import React from 'react'

const StatusChangePopup = (props) => {
    const {botCurrentStatus, botStatusErrorMsg} = props;
    return (
        <>
            <div className="menu menu-sub menu-sub-dropdown w-250px w-md-250px p-3" data-sai-menu="true">
                {
                    botCurrentStatus === 'failed' ? (
                        <>
                            <div className="menu-item">
                                <div 
                                    className="menu-link px-3 text-gray-600 fw-semibold" 
                                >
                                    {botStatusErrorMsg}
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            {(botCurrentStatus === 'draft' || botCurrentStatus === 'complete') && 
                                <div className="menu-item">
                                    <a 
                                        className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" 
                                        onClick={() => props.statusChangeOnClick('live')}
                                    >
                                        Live
                                    </a>
                                </div>
                            }
                            {(botCurrentStatus === 'live' || botCurrentStatus === 'success' || botCurrentStatus === 'complete') && 
                                <div className="menu-item">
                                    <a 
                                        className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" 
                                        onClick={() => props.statusChangeOnClick('draft')}
                                    >
                                        Draft
                                    </a>
                                </div>
                            }
                        </>
                    )
                }
            </div>
        </>
    )
}

export default StatusChangePopup